import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$x.right },
    [
      _vm.markets
        ? _c("ns-select", {
            staticClass: "flex-column",
            attrs: {
              name: "countrySelect",
              items: _vm.markets,
              label: _vm.t.market,
              rules: _vm.nameRule,
            },
            on: { input: _vm.marketChanged },
            model: {
              value: _vm.marketSelection,
              callback: function ($$v) {
                _vm.marketSelection = $$v
              },
              expression: "marketSelection",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        VForm,
        { ref: "addressForm" },
        [
          _vm.f.addressName.show
            ? _c(VTextField, {
                staticClass: "flex-column",
                attrs: {
                  name: "addressName",
                  maxlength: _vm.f.addressName.maxLength,
                  required: _vm.f.addressName.required,
                  rules: _vm.f.addressName.required ? _vm.nameRule : [],
                  disabled: _vm.disableAddressName,
                  "validate-on-blur": "",
                  label: _vm.t.addressName,
                },
                on: { input: _vm.fieldUpdated },
                model: {
                  value: _vm.addressName,
                  callback: function ($$v) {
                    _vm.addressName = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "addressName",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("ns-address", {
            attrs: {
              lang: _vm.language,
              country: _vm.marketSelection.toUpperCase(),
              "include-email": _vm.includeEmail,
              "email-required": _vm.emailRequired,
            },
            on: { "new-address-in-form": _vm.validateNewAddress },
            model: {
              value: _vm.address,
              callback: function ($$v) {
                _vm.address = $$v
              },
              expression: "address",
            },
          }),
          _vm._v(" "),
          _vm.f.phone.show
            ? _c("ns-phone-number-lib", {
                staticClass: "flex-column",
                attrs: {
                  number: _vm.mobilePhone,
                  name: "mobilePhone",
                  country: _vm.mobilePhoneCountry || _vm.country,
                  label: _vm.t.mobilePhoneLabel || _vm.t.phoneLabel,
                  "invalid-message": _vm.t.invalidPhone,
                  "error-message": _vm.t.fieldRequired,
                },
                on: { input: _vm.phoneUpdated },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.f.instructions.show
            ? _c(VTextField, {
                staticClass: "flex-column",
                attrs: {
                  name: "instructions",
                  maxlength: _vm.f.instructions.maxLength,
                  label: _vm.t.instructionsLabel,
                  rules: _vm.f.instructions.required ? _vm.nameRule : [],
                },
                on: { input: _vm.fieldUpdated },
                model: {
                  value: _vm.instructions,
                  callback: function ($$v) {
                    _vm.instructions =
                      typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "instructions",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }